import { render, staticRenderFns } from "./SearchServiceWrapper.vue?vue&type=template&id=46962788"
import script from "./SearchServiceWrapper.vue?vue&type=script&lang=js"
export * from "./SearchServiceWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports